import { useEffect, useMemo } from 'react'
import cn from 'classnames'

import { Typography } from 'components/Typography'
import { useRFPSurveyContext } from 'features/RFP/RFPDetails/Providers/RFPSurveyContextProvider'
import { CreateSurveyButton } from 'features/RFP/RFPSurvey/CreateSurvey/CreateSurveyButton'
import RFPCreateSurveyContextProvider from 'features/RFP/RFPSurvey/CreateSurvey/Providers/RFPCreateSurveyContextProvider'
import {
  CreateSurveyPopup,
  SubmitSurveyPopup
} from 'features/RFP/RFPSurvey/CreateSurvey/index'
import { useRFPDetailsContext } from 'features/RFP/RFPDetails/Providers/RFPDetailsContextProvider'
import { SurveyResults } from '../SurveyResults'
import { useRFPVotingContext } from 'features/RFP/RFPDetails/Providers/RFPVotingContextProvider'
import { OpenSurveyButton } from './OpenSurveyButton'
import './styles.scss'
import { ACTIONS, Can, SUBJECTS } from 'features/Permission'
import { subject } from '@casl/ability'
import { RFP_STATUSES } from '../../constants'
import RankingUnchangedPopup from './RankingUnchangedPopup'
import SubmitConfirmPopup from './SubmitConfirmPopup'
import '../styles.scss'
import { ViewSurveyActions } from './ViewSurveyActions/ViewSurveyActions'
import { EditSurveyFromHospitalUser } from './Actions/EditSurveyFromHospitalUser/EditSurveyFromHospitalUser'

const CreateSurvey = () => {
  const rfpSurveyContext = useRFPSurveyContext()
  const rfpDetailsContext = useRFPDetailsContext()
  const rfpVotingContext = useRFPVotingContext()

  const {
    data,
    isCurrentUserHospitalUser,
    isCurrentUserCommonsStakeholderAndFU
  } = rfpDetailsContext.state
  const { isSurveyCreated, isSurveySubmitted } = rfpSurveyContext.state
  const { isVotingInProgress } = rfpVotingContext.state

  const { getRfpAcceptedVendorListAsync, getHospitalUserVoteAsync } =
    rfpSurveyContext.actions

  const isSurveySubmittedAndHospitalUserAndFu = useMemo(
    () =>
      (isCurrentUserHospitalUser || isCurrentUserCommonsStakeholderAndFU) &&
      isSurveySubmitted,
    [
      isCurrentUserCommonsStakeholderAndFU,
      isCurrentUserHospitalUser,
      isSurveySubmitted
    ]
  )

  useEffect(() => {
    getRfpAcceptedVendorListAsync()
  }, [getRfpAcceptedVendorListAsync])

  useEffect(() => {
    if (
      (isCurrentUserHospitalUser || isCurrentUserCommonsStakeholderAndFU) &&
      (data.status === RFP_STATUSES.VENDORS_SELECTION ||
        data.status === RFP_STATUSES.VOTING_IN_PROGRESS ||
        data.status === RFP_STATUSES.ARCHIVED)
    ) {
      getHospitalUserVoteAsync()
    }
  }, [
    getHospitalUserVoteAsync,
    isCurrentUserHospitalUser,
    data.status,
    isCurrentUserCommonsStakeholderAndFU
  ])

  return (
    <RFPCreateSurveyContextProvider>
      <div className="create-survey">
        <div className="create-survey__header">
          <Typography.Headline6
            className={cn('create-survey__title', {
              'create-survey__title--submitted':
                isSurveySubmittedAndHospitalUserAndFu
            })}
          >
            Survey
          </Typography.Headline6>
          {isSurveyCreated && !isSurveySubmittedAndHospitalUserAndFu && (
            <ViewSurveyActions />
          )}
          {isSurveySubmittedAndHospitalUserAndFu && isVotingInProgress && (
            <EditSurveyFromHospitalUser />
          )}
        </div>
        <Can I={ACTIONS.VIEW} a={subject(SUBJECTS.VOTING_RESULTS, { ...data })}>
          {isSurveyCreated && <SurveyResults rfpID={data.uuid} />}
        </Can>
        {!isSurveyCreated && <CreateSurveyButton />}
        {isSurveyCreated &&
          !isSurveySubmittedAndHospitalUserAndFu &&
          isVotingInProgress && (
            <div className="create-survey__actions">
              <OpenSurveyButton />
            </div>
          )}
      </div>
      <CreateSurveyPopup />
      <SubmitSurveyPopup />
      <RankingUnchangedPopup />
      <SubmitConfirmPopup />
    </RFPCreateSurveyContextProvider>
  )
}

export default CreateSurvey
